export default __webpack_public_path__ + "static/media/bg22.fb0f4ae5.jpg";